import Constant from '@/const';
import axios from 'axios';

const postUnit = async payload => {
  try {
    const response = await axios.post(
      Constant.apiUrl.concat('/master/unit/'),
      payload,
    );
    return response;
  } catch (error) {
    this.showErrorAxios(error);
  }
};

export default postUnit;
